import {Form, Select} from 'antd';
import {useCallback} from 'react';

const frequencyUnitOptions = [
    {label: 'Day', value: 'day'},
    {label: 'Week', value: 'week'},
    {label: 'Month', value: 'month'},
    {label: 'Year', value: 'year'},
];

type FrequencyUnitProps = {
    frequency: number;
}

export function FrequencyUnit({frequency}: FrequencyUnitProps) {
    const labelRenderer = useCallback(({label}: any) => {
        return `${label}${frequency > 1 ? 's' : ''}`
    }, [frequency]);

    return (
        <Form.Item
            label={' '}
            name={'frequencyUnit'}
        >
            <Select
                id={'frequencyUnit'}
                options={frequencyUnitOptions}
                labelRender={labelRenderer}
                optionRender={labelRenderer}
            />
        </Form.Item>
    )
}
